import * as R from 'ramda'

export const labelType: {
  [key: string]: string;
} = {
  TICKET: 'Ticket',
  POLICY: 'Policy',
  QUOTE: 'Quote'
}

export const labelTypeKeys = R.keys(labelType)
export const labelTypeValues = R.values(labelType)
